<template>
  <b-row align-v="start" class="pb-3">
    <b-col sm="3" align="center" class="label-col pb-3 pt-2">
      <label :label-for="id">
        {{ titleText }}
      </label>
    </b-col>
    <b-col sm="9">
      <b-row>
        <b-col sm="4">
          <b-form-radio-group
            :id="id"
            v-model="inputValue"
            :options="options"
            :state="isValid"
            buttons
            button-variant="outline-primary"
          />
        </b-col>
        <b-col sm="8">
          <b-form-textarea
            v-model="inputText"
            :disabled="inputValue !== 1"
            :state="isValid"
            placeholder="Enter feature description"
          />
        </b-col>
      </b-row>

      <b-form-invalid-feedback
        v-if="!(validation===undefined)"
        :id="id + 'Invalid'"
        align="left"
      >
        <font-awesome-icon :icon="['far','exclamation-triangle']" />{{ validationText }}
      </b-form-invalid-feedback>

      <b-row>
        <b-col>
          <b-form-text :label-for="id">
            {{ description }}
          </b-form-text>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

  import {mapMutations} from 'vuex';
  import {getValidationMessages} from './../../../../js/validation/validationMessages.js'

  export default {
    name: "RxCheckBoxWithText",
    props: {
      value: {
        type: Number,
        required: true
      },
      text: {
        type: String,
        required: false,
        default: () => ""
      },
      options:  {
        type: Array,
        required: true
      },
      description: {
        type: String,
        required: false,
        default: () => {}
      },
      titleText: {
        type: String,
        required: true
      },
      id:{
        type: String,
        required: true
      },
      validation: {
        type: Object,
        required: false,
        default: () => {}
      }
    },

    computed: {
      inputValue: {
        // inputValue's getter and setter allow v-model to chain down to subcomponents with
        // two-way binding intact.
        get() {
          return this.value
        },
        set(v) {
          if (this.validation !== undefined && this.validation !== null){
            this.validation.$touch()
          } else {
            this.setPageDirty()
          }
          this.$emit('input',v)
        },
      },
      inputText: {
        get() {
          return this.text
        },
        set(v) {
          if (this.validation !== undefined && this.validation !== null){
            this.validation.$touch()
          } else {
            this.setPageDirty()
          }
          this.$emit('update:text', v)
        }
      },
      isValid() {
        if (this.validation !== undefined){
          if (this.validation.$dirty){
            return !this.validation.$error
          }
        }
        return null
      },
      validationText() {
        if (this.validation !== undefined){
          return getValidationMessages(this.validation)
        }
      },
    },
    methods:{
      ...mapMutations('rx',[
        'setPageDirty'
      ])
    },
  }

</script>

<style scoped>
  .label-col {
    font-size: 1.2rem;
  }

  label {
    text-align: center;
  }
</style>